import {
  DELETE_FROM_COMPARISON,
  IDeleteFromComparison,
  ISetComparisonNotification,
  SET_COMPARISON_NOTIFICATION,
} from '../../constants/actionTypes/offersComparison';
import { IDeleteOfferFromComparisonResponse } from '../../repositories/offers-comparison/entities/delete_offer_from_comparison/DeleteOfferFromComparisonResponse';
import { deleteOfferFromComparisonRequest } from '../../services/offersComparison';
import { EComparisonNotificationCategory } from '../../types/offersComparion';
import { TThunkAction } from '../../types/redux';

interface IDeleteFromComparisonParameters {
  entityId: number;
}

export function deleteOfferFromComparison({ entityId }: IDeleteFromComparisonParameters): TThunkAction {
  return async (dispatch, getState, context) => {
    const { httpApi } = context;

    const response = await deleteOfferFromComparisonRequest({ httpApi, parameters: { offerId: entityId } });

    if (response) {
      const { offerId, text, comparisonUrl } = response as unknown as IDeleteOfferFromComparisonResponse;

      dispatch<IDeleteFromComparison>({
        type: DELETE_FROM_COMPARISON,
        offerId,
      });

      dispatch<ISetComparisonNotification>({
        type: SET_COMPARISON_NOTIFICATION,
        text,
        url: comparisonUrl,
        category: EComparisonNotificationCategory.Remove,
        offerId,
      });
    }
  };
}
